import * as React from "react";
import classnames from "classnames";
import { ButtonDropdown } from "@grandvisionhq/common";
import { COLUMNED_DROPDOWN_PLACEHOLDER } from "./constants.js";
/* empty css                        */
const PLACEHOLDER = "---";
const DualColumnDropdown = ({
  "data-t": dataT,
  className,
  id,
  isDisabled,
  isInvalid,
  isRequired,
  label,
  onChange,
  options,
  selectedValue
}) => {
  const containsPlaceholder = Object.values(options).includes(PLACEHOLDER);
  const containsZero = Object.values(options).some((value) => Number(value) === 0);
  const optionsArray = Object.entries(options).map(([key, value]) => ({
    label: key,
    value
  }));
  const negativeOptions = optionsArray.filter((power) => Number(power.value) < 0).sort((a, b) => Number(a.label) - Number(b.label)).reverse();
  const positiveOptions = optionsArray.filter((power) => Number(power.value) > 0).sort((a, b) => Number(a.label) - Number(b.label));
  const maxLength = Math.max(negativeOptions.length, positiveOptions.length);
  const rows = Array.from({ length: maxLength }, (_, index) => {
    return [{ ...negativeOptions[index] }, { ...positiveOptions[index] }];
  });
  return /* @__PURE__ */ React.createElement(
    ButtonDropdown,
    {
      "aria-label": label,
      className: classnames(className, "dual-columned-dropdown"),
      "data-t": dataT,
      isDisabled,
      isInvalid,
      isRequired,
      onChange,
      value: selectedValue,
      cols: 2,
      orientation: "both",
      itemSizes: optionsArray.map((_, index) => {
        if (containsZero && index === 0) {
          return { width: 2, height: 1 };
        }
        return { width: 1, height: 1 };
      })
    },
    /* @__PURE__ */ React.createElement(
      ButtonDropdown.Select,
      {
        placeholder: COLUMNED_DROPDOWN_PLACEHOLDER,
        className: "dual-columned-dropdown__select",
        id
      }
    ),
    /* @__PURE__ */ React.createElement(ButtonDropdown.Content, { type: "select", className: "dual-columned-dropdown__content" }, containsPlaceholder ? /* @__PURE__ */ React.createElement(
      ButtonDropdown.GridRow,
      {
        className: classnames(
          "dual-columned-dropdown__row",
          "dual-columned-dropdown__row--full-width"
        )
      },
      /* @__PURE__ */ React.createElement(ButtonDropdown.GridCell, { className: "dual-columned-dropdown__cell" }, /* @__PURE__ */ React.createElement(ButtonDropdown.Option, { value: PLACEHOLDER, className: "dual-columned-dropdown__option" }, PLACEHOLDER))
    ) : null, containsZero ? /* @__PURE__ */ React.createElement(
      ButtonDropdown.GridRow,
      {
        className: classnames(
          "dual-columned-dropdown__row",
          "dual-columned-dropdown__row--full-width"
        )
      },
      /* @__PURE__ */ React.createElement(ButtonDropdown.GridCell, { className: "dual-columned-dropdown__cell" }, /* @__PURE__ */ React.createElement(ButtonDropdown.Option, { value: 0, className: "dual-columned-dropdown__option" }, "0.00"))
    ) : null, rows.map((options2) => /* @__PURE__ */ React.createElement(
      ButtonDropdown.GridRow,
      {
        key: `${options2?.[0]?.value}-${options2?.[1]?.value}`,
        className: "dual-columned-dropdown__row"
      },
      options2.map((option) => {
        if (!option)
          return /* @__PURE__ */ React.createElement(
            ButtonDropdown.GridCell,
            {
              key: "empty-cell",
              className: "dual-columned-dropdown__cell"
            },
            /* @__PURE__ */ React.createElement(ButtonDropdown.EmptyOption, { className: "dual-columned-dropdown__option" })
          );
        return option.value ? /* @__PURE__ */ React.createElement(
          ButtonDropdown.GridCell,
          {
            key: option.value,
            className: "dual-columned-dropdown__cell"
          },
          /* @__PURE__ */ React.createElement(
            ButtonDropdown.Option,
            {
              value: option.value,
              className: "dual-columned-dropdown__option"
            },
            option.label
          )
        ) : null;
      })
    )))
  );
};
export {
  DualColumnDropdown
};
//# sourceMappingURL=DualColumnDropdown.js.map
